import {ChangeDetectionStrategy, Component, Inject, Input, OnChanges, OnInit, SimpleChanges} from "@angular/core";

require('./bringoz-package-item.scss');
@Component({
  standalone: false,
  selector: 'app-bringoz-package-item',
  templateUrl: './bringoz-package-item.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozPackageItemComponent implements OnInit, OnChanges {
  @Input() id: string;
  @Input() icon: string;
  @Input() name: string;
  @Input() count?: number;
  @Input() nameOnly?: boolean;
  @Input() packingDisplayStatus?: string;
  @Input() isMissingPackage?: boolean;

  public sitePackageItemsMap: {};
  public item: any;


  constructor(@Inject('splitService') private splitService) {
  }

  ngOnInit() {
    this.sitePackageItemsMap = this.splitService.getSitePackageItemsMap();
    this.item = this.id ? this.sitePackageItemsMap[this.id] : undefined;

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.id && !changes.id.isFirstChange()) {
      this.item = this.id ? this.sitePackageItemsMap[this.id] : undefined;
    }
  }

}
